import { render, staticRenderFns } from "./inbound-call-failed-icon.vue?vue&type=template&id=2bfbbd2c"
import script from "./inbound-call-failed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports